// app/javascript/controllers/form_loader_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["submitButton", "spinner", "submitText"]
    static values = { submittingText: String }

    connect() {
        // Cache original content so we can restore it later
        if (this.hasSubmitButtonTarget) this._originalButtonHTML = this.submitButtonTarget.innerHTML
        if (this.hasSubmitTextTarget)   this._originalSubmitText = this.submitTextTarget.textContent

        this.element.addEventListener("turbo:submit-start", this.showLoader)
        this.element.addEventListener("turbo:submit-end", this.hideLoader)
        this.element.addEventListener("reset", this.hideLoader)
    }

    disconnect() {
        this.element.removeEventListener("turbo:submit-start", this.showLoader)
        this.element.removeEventListener("turbo:submit-end", this.hideLoader)
        this.element.removeEventListener("reset", this.hideLoader)
    }

    showLoader = () => {
        if (this.hasSubmitButtonTarget) this.submitButtonTarget.disabled = true
        if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("d-none")

        let text = this.hasSubmittingTextValue ? this.submittingTextValue : null
        if (!text && this.hasSubmitButtonTarget) {
            text = this.submitButtonTarget.getAttribute("data-submitting-text")
        }
        if (!text) text = "Submitting..."

        if (this.hasSubmitTextTarget) {
            this.submitTextTarget.textContent = text
        } else if (this.hasSubmitButtonTarget) {
            // Change the whole button text while preserving cached original HTML for restore
            this.submitButtonTarget.textContent = text
        }
    }

    hideLoader = () => {
        if (this.hasSubmitButtonTarget) {
            this.submitButtonTarget.disabled = false
            // Restore original HTML/text
            if (this._originalButtonHTML != null) {
                this.submitButtonTarget.innerHTML = this._originalButtonHTML
            }
        }
        if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("d-none")
        if (this.hasSubmitTextTarget && this._originalSubmitText != null) {
            this.submitTextTarget.textContent = this._originalSubmitText
        }
    }
}